import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: 'Fenêtres PVC', path: '/reparation-fenetre-pvc-paris-15/' },
  { label: 'Fenêtres Aluminium', path: '/reparation-fenetre-aluminium-paris-15/' },
  { label: 'Fenêtres Bois', path: '/reparation-fenetre-bois-paris-15/' },
  { label: 'Baies Vitrées', path: '/reparation-baie-vitree-paris-15/' },
  { label: 'Volets Roulants', path: '/reparation-volet-roulant-paris-15/' },
  { label: 'Motorisation Volets', path: '/motorisation-volet-roulant-paris-15/' },
];

const quartierLinks = [
  { label: 'Javel', path: '/quartier-javel/' },
  { label: 'Beaugrenelle', path: '/quartier-beaugrenelle/' },
  { label: 'Grenelle', path: '/quartier-grenelle/' },
  { label: 'Vaugirard', path: '/zones-intervention-paris-15/' },
  { label: 'Convention', path: '/zones-intervention-paris-15/' },
  { label: 'Front de Seine', path: '/zones-intervention-paris-15/' },
  { label: 'Tous les quartiers', path: '/zones-intervention-paris-15/' },
];

export default function Footer() {
  return (
    <footer className="w-full" role="contentinfo">
      {/* Teal CTA bar */}
      <div className="bg-brand-accent">
        <div className="px-4 md:px-6 py-10 md:py-14 max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-bold text-white font-heading">Devis gratuit — Intervention 24/48h</h3>
              <p className="text-sm text-white/80 mt-1">01 87 66 81 55 · WhatsApp · Paris 15ᵉ</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a href="tel:+33187668155" className="inline-flex items-center justify-center gap-2 bg-white hover:opacity-90 text-brand-accent font-semibold text-sm px-6 py-3 rounded-full transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-phone-fill text-base"></i>
                01 87 66 81 55
              </a>
              <a
                href="https://wa.me/+33745883392?text=Bonjour%20DF%20PRO"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1faa52] text-white font-semibold text-sm px-6 py-3 rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-base"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Dark footer section */}
      <div className="bg-brand-dark">
        <div className="px-4 md:px-6 py-12 md:py-16 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
            {/* Logo + description */}
            <div className="lg:col-span-4">
              <Link to="/" aria-label="DF PRO — Réparation de fenêtres à Paris 15 — Retour à l'accueil" className="inline-block mb-5">
                <img
                  src="/logo_dfpro_footer.svg"
                  alt="DF PRO — Réparation de fenêtres à Paris 15"
                  className="h-[40px] w-auto"
                />
              </Link>
              <p className="text-sm text-white/60 leading-relaxed mb-5 max-w-sm">
                Réparation de fenêtres, menuiseries, baies vitrées et volets roulants à Paris 15ᵉ. Intervention 24/48h, devis gratuit, techniciens salariés, société assurée.
              </p>
              <div className="flex flex-col gap-3">
                <a href="tel:+33187668155" className="inline-flex items-center gap-2.5 text-white hover:text-brand-accent transition-colors text-sm whitespace-nowrap cursor-pointer group">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 group-hover:bg-white/20 transition-colors">
                    <i className="ri-phone-fill text-brand-accent text-sm"></i>
                  </div>
                  01 87 66 81 55
                </a>
                <a href="https://wa.me/+33745883392" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 text-white hover:text-[#25D366] transition-colors text-sm whitespace-nowrap cursor-pointer group">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 group-hover:bg-[#25D366]/20 transition-colors">
                    <i className="ri-whatsapp-fill text-brand-accent text-sm"></i>
                  </div>
                  WhatsApp
                </a>
              </div>
            </div>

            {/* Services */}
            <div className="lg:col-span-3">
              <h4 className="text-xs font-semibold text-brand-accent uppercase tracking-wider mb-5">Services</h4>
              <div className="flex flex-col gap-3">
                {serviceLinks.map((link) => (
                  <Link key={link.path} to={link.path} className="inline-flex items-center gap-2.5 text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer group">
                    <i className="ri-window-line text-brand-accent text-sm"></i>
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Quartiers */}
            <div className="lg:col-span-3">
              <h4 className="text-xs font-semibold text-brand-accent uppercase tracking-wider mb-5">Quartiers du 15ᵉ</h4>
              <div className="flex flex-col gap-2.5">
                {quartierLinks.map((link) => (
                  <Link key={link.path + link.label} to={link.path} className="inline-flex items-center gap-1.5 text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                    <i className="ri-map-pin-fill text-brand-accent text-[10px]"></i>
                    {link.label}
                  </Link>
                ))}
              </div>
              <div className="mt-5 pt-4 border-t border-white/10">
                <span className="text-xs text-white/40 leading-relaxed">Vaugirard · Grenelle · Javel · Beaugrenelle · Saint-Lambert · Necker · Convention</span>
              </div>
            </div>

            {/* Contact */}
            <div className="lg:col-span-2">
              <h4 className="text-xs font-semibold text-brand-accent uppercase tracking-wider mb-5">Contact</h4>
              <div className="flex flex-col gap-3 mb-6">
                <Link to="/qui-sommes-nous/" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Qui sommes-nous</Link>
                <Link to="/contact/" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Contact</Link>
                <Link to="/blog/" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Blog</Link>
                <Link to="/zones-intervention-paris-15/" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Zones d'intervention</Link>
              </div>
              <div className="bg-white/5 rounded-xl p-4 border border-white/10">
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-time-line text-brand-accent text-sm"></i>
                  <span className="text-xs font-semibold text-white">Horaires</span>
                </div>
                <div className="space-y-1">
                  <div className="flex justify-between text-xs">
                    <span className="text-white/60">Lun–Ven</span>
                    <span className="text-white font-medium">8:00 – 19:00</span>
                  </div>
                  <div className="flex justify-between text-xs">
                    <span className="text-white/60">Sam</span>
                    <span className="text-white font-medium">9:00 – 14:00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom copyright bar */}
        <div className="border-t border-white/10">
          <div className="px-4 md:px-6 py-5 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-white/40">&copy; {new Date().getFullYear()} DF PRO. Tous droits réservés.</p>
            <div className="flex items-center gap-5">
              <Link to="/mentions-legales/" className="text-xs text-white/40 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Mentions légales</Link>
              <Link to="/plan-du-site/" className="text-xs text-white/40 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Plan du site</Link>
              <span className="text-white/20">·</span>
              <span className="inline-flex items-center gap-1.5 text-xs text-white/40">
                <i className="ri-map-pin-2-line text-brand-accent"></i>
                Paris 15ᵉ — 75015
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}